export const SELECT_SERVICE_ACCOUNT = 'SELECT_SERVICE_ACCOUNT';
export const SET_SPK_FOR_LOGGING_CHECK = 'SET_SPK_FOR_LOGGING_CHECK';
export const SET_LOGIN_ACCOUNT = 'SET_LOGIN_ACCOUNT';
export const SET_SERVICE_ACCOUNTS = 'SET_SERVICE_ACCOUNTS';
export const SET_MENU_TOGGLE = 'SET_MENU_TOGGLE';
export const HAVE_SERVICE_ACCOUNT = 'HAVE_SERVICE_ACCOUNT';
export const LOGIN_ACCOUNT_ROLE = 'LOGIN_ACCOUNT_ROLE';
export const SET_PLAYER_SNAPSHOT = 'SET_PLAYER_SNAPSHOT';
export const SET_PUSHER = 'SET_PUSHER';
export const SET_GOOGLE_CONFIG = 'SET_GOOGLE_CONFIG';
export const HAVE_SERVICE_ACCOUNT_CONTRACT = 'HAVE_SERVICE_ACCOUNT_CONTRACT';
export const LOCATION = 'LOCATION';
export const SELECT_SERVICE_ACCOUNT_CONTRACT = 'SELECT_SERVICE_ACCOUNT_CONTRACT';
export const SET_CONFIG = 'SET_CONFIG';
export const SELECT_SERVICE_ACCOUNT_ADDITIONAL_INFO = 'SELECT_SERVICE_ACCOUNT_ADDITIONAL_INFO';
